import React, {useCallback, useEffect, useState} from 'react'
import Button from '@mui/joy/Button'
import {useNavigate, useLocation} from 'react-router-dom'
import Typography from '@mui/joy/Typography'
import GoogleIcon from '@mui/icons-material/Google'
import Box from '@mui/joy/Box'
import {Card, CardContent} from '@mui/joy'
import {useSignInWithGoogleMutation} from '../services/auth'
import {useDispatch, useSelector} from "react-redux";
import {selectAuth, setToken} from "../slice/AuthSlice";


function GoogleAuth() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const {token} = useSelector(selectAuth)

  const [signInWithGoogle, {isLoading, isError}] =
    useSignInWithGoogleMutation({fixedCacheKey: 'shared-delete-reward'})

  const handleLogin = () => {
    window.location.href =
      'https://customer-auth.gyore-soma.workers.dev/auth/login'
  }

  const handleCallback = async (code: string) => {
    if (!code || isLoading) {
      return
    }

    console.log("code")
    console.log(code)
    console.log("handleCallback")

    try {

      const response = await signInWithGoogle({code}).unwrap()

      console.log("response.accessToken")
      console.log(response.accessToken)

      dispatch(setToken(response.accessToken))

      if (response.accessToken) {
        localStorage.setItem('token', response.accessToken)
      }

      localStorage.setItem('customerName', response.user.name)
      navigate(location.pathname, {replace: true})

      window.location.reload()

      // navigate('/')
    } catch (err) {
      console.error('Authentication error:', err)
    }
  }

  useEffect(() => {
    (async () => {
      const urlParams = new URLSearchParams(location.search)
      const code = urlParams.get('code')
      if (!code) return

      await handleCallback(code)
    })()
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height
        backgroundColor: '#f5f5f5', // Light background for contrast
      }}
    >
      <Card
        variant="outlined"
        sx={{
          width: 400,
          padding: 2,
          boxShadow: 'md',
          borderRadius: 'lg',
          textAlign: 'center',
          backgroundColor: '#fff', // White card background
        }}
      >
        <CardContent>
          <Typography level="h4" fontWeight="lg" mb={2}>
            Bejelentkezés
          </Typography>
          <Button
            variant="outlined"
            color="neutral"
            startDecorator={<GoogleIcon/>}
            sx={{
              fontWeight: 'md',
              borderRadius: '8px',
              borderColor: '#747775',
              color: '#1F1F1F',
              '&:hover': {
                backgroundColor: '#F2F2F2',
              },
            }}
            onClick={handleLogin}
            disabled={isLoading}
          >
            Bejelentkezés Google fiókkal
          </Button>
          {isLoading && (
            <Typography mt={2} color="neutral">
              Bejelentkezés folyamatban...
            </Typography>
          )}
          {isError && (
            <Typography mt={2} color="danger">
              Hiba történt a bejelentkezés során.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default GoogleAuth
